/**
 * Recursively filters a JSON object down to the branches matching `searchFilter`.
 */
export default (obj, searchFilter) => {
	const filter = searchFilter.toLowerCase();

	// Counts nested entries so children of a matched parent stay visible.
	let count = 0;

	const _findCount = (object) => {
		if (typeof object === 'object' && object !== null) {
			count += Object.keys(object).length;
			for (const value of Object.values(object)) {
				_findCount(value);
			}
		}
	};

	const _searchJSON = (value, key, search) => {
		for (const [tempKey, tempValue] of Object.entries(value)) {
			if (tempKey.toLowerCase().includes(search) && isNaN(tempKey)) {
				return true;
			}
			if (typeof tempValue === 'object' && tempValue !== null) {
				if (_searchJSON(tempValue, tempKey, search)) return true;
			} else if (typeof tempValue === 'string') {
				if (tempValue.toLowerCase().includes(search)) return true;
			}
		}
		return false;
	};

	return JSON.parse(
		JSON.stringify(obj, (key, value) => {
			if (count > 0) {
				count -= 1;
				return value;
			}
			if (key.toLowerCase().includes(filter) && isNaN(key)) {
				_findCount(value);
				return value;
			}
			if (typeof value === 'object' && value !== null) {
				if (_searchJSON(value, key, filter)) return value;
			} else if (typeof value === 'string') {
				if (value.toLowerCase().includes(filter)) return value;
			}
			return undefined;
		})
	);
};
